import { memo, useMemo } from 'react';
import { CardWrapperPreview } from './wrappers/CardWrapperPreview';
import { useCardWrapperSections } from '../hooks/useCardSections';
import { useCardContentSectionSettings, useQuickActionSettings } from '../hooks/useCardSections';
import { RenderSectionComponent } from './CrmObjectBoardCard';
import { useCardContentPreviewSections } from '../sections/hooks/useCardContentPreviewSections';
import { Flex } from 'foundations-components/components/Flex';
import { useCardActionPreviewSections } from '../sections/hooks/useCardActionPreviewSections';
import { ExpandActionButton } from '../sections/components/ExpandActionButton';
import { ExpanderProvider } from './expander/ExpanderProvider';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WrapperSections = ({
  children
}) => {
  const cardWrapperSections = useCardWrapperSections();
  const wrapper = cardWrapperSections.reduceRight((child, section) => {
    const {
      PreviewComponent
    } = section;
    if (!PreviewComponent) {
      return child;
    }
    return /*#__PURE__*/_jsx(PreviewComponent, {
      children: child
    });
  }, children);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: wrapper
  });
};
export const ContentSections = /*#__PURE__*/memo(() => {
  const contentSectionSettings = useCardContentSectionSettings();
  const previewSections = useCardContentPreviewSections(contentSectionSettings);
  const content = contentSectionSettings.map((sectionSettings, index) => {
    const previewComponent = previewSections.get(sectionSettings.sectionKey);
    if (!previewComponent) return null;
    const sectionKey = sectionSettings.sectionKey;
    return /*#__PURE__*/_jsx(RenderSectionComponent, {
      Component: previewComponent,
      settings: sectionSettings.settings,
      sectionKey: sectionKey
    }, `${sectionKey}-${index}`);
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: content
  });
});
const ActionSections = () => {
  const quickActionSettings = useQuickActionSettings();
  const settings = useMemo(() => {
    return (quickActionSettings === null || quickActionSettings === void 0 ? void 0 : quickActionSettings.settings) || {
      quickActions: [{
        type: 'PREVIEW',
        displayOrder: 0
      }]
    };
  }, [quickActionSettings]);
  const cardActionSections = useCardActionPreviewSections(settings);
  const actions = cardActionSections.map(section => {
    const {
      sectionKey,
      PreviewComponent
    } = section;
    if (!PreviewComponent) return null;
    return /*#__PURE__*/_jsx(PreviewComponent, {}, sectionKey);
  });

  //@bend-expect trellis-tokenized
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(Flex, {
      justifyContent: "start",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(ButtonGroup, {
        children: actions
      })
    }), /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(ExpandActionButton, {})
    })]
  });
};
const CrmObjectBoardCardPreview = /*#__PURE__*/memo(() => {
  return /*#__PURE__*/_jsx(CardWrapperPreview, {
    children: /*#__PURE__*/_jsx(WrapperSections, {
      children: /*#__PURE__*/_jsxs(ExpanderProvider, {
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(ContentSections, {})
        }), /*#__PURE__*/_jsx(ActionSections, {})]
      })
    })
  });
});
export { CrmObjectBoardCardPreview };